import type { AchievementCategoryMap, AchievementLevelData } from "atoms/Ltool/matrixAtoms";
import { isRecord, toNumberOrNull } from "utils/achievementConfigForm";

// 達成度判断表 GET のレスポンスを、画面が前提にする形（AchievementLevelData）へ正規化する。
// `response.json()` は any で、型注釈だけでは形を保証できない。表は偏差に `.toFixed` を掛けるため、
// BE との食い違いや想定外の形でも落とさず、欠落は未計算（null）として扱う。
// 数値は設定画面（#49）と同様に数値文字列を許容する。

const toEntry = (value: unknown) => ({
    assessment: isRecord(value) && typeof value.assessment === "string" ? value.assessment : null,
    deviation_max: isRecord(value) ? toNumberOrNull(value.deviation_max) : null,
});

const toRiskMargin = (value: unknown): Record<string, number> | undefined => {
    if (!isRecord(value)) return undefined;
    return Object.fromEntries(
        Object.entries(value).flatMap(([groupId, margin]) => {
            const parsed = toNumberOrNull(margin);
            return parsed === null ? [] : [[groupId, parsed]];
        }),
    );
};

export const toAchievementLevelData = (body: unknown): AchievementLevelData => {
    const root = isRecord(body) ? body : {};
    const levels = isRecord(root.achievement_level) ? root.achievement_level : {};
    const achievementLevel = Object.fromEntries(
        Object.entries(levels).flatMap(([unitId, conditions]): [string, AchievementCategoryMap][] =>
            isRecord(conditions)
                ? [[unitId, Object.fromEntries(Object.entries(conditions).map(([id, entry]) => [id, toEntry(entry)]))]]
                : [],
        ),
    );
    const riskMargin = toRiskMargin(root.risk_margin);
    return {
        message: typeof root.message === "string" ? root.message : "",
        ...(riskMargin ? { risk_margin: riskMargin } : {}),
        achievement_level: achievementLevel,
    };
};
